/*********************************************************************************************
 * Constants and utilities
 */
const MONTHS_SHORT = window.MONTHS_SHORT || ["janv", "févr", "mars", "avr", "mai", "juin", "juil", "août", "sept", "oct", "nov", "déc"];
window.MONTHS_SHORT = MONTHS_SHORT;

/*********************************************************************************************
 * Error handling utility
 */
function handleCartError(error, customMessage = "Une erreur est survenue") {
	console.error(customMessage, error);
	const errorMessage = error.message || error.description || customMessage;
	if (errorMessage && errorMessage !== "undefined") {
		alert(errorMessage);
	}
	location.reload();
}

/*********************************************************************************************
 * Update cart total data in DOM for progress bar
 */
function updateCartDataInDOM() {
	// Récupérer le total actuel depuis l'API Shopify
	fetch('/cart.js')
		.then(response => response.json())
		.then(cart => {
			const dataElement = document.querySelector('[data-cart-total-cents]');
			if (dataElement) {
				dataElement.setAttribute('data-cart-total-cents', cart.total_price);
				// console.log('Updated cart total in DOM:', cart.total_price);

				// Mettre à jour la progress bar avec les nouvelles données
				if (typeof updateProgressBarForDelivery === "function") {
					setTimeout(updateProgressBarForDelivery, 100);
				}
			}
		})
		.catch(error => {
			console.error('Error updating cart data:', error);
		});
}

// Date range option delivery
// Fonction pour calculer les jours ouvrés
function calculateBusinessDays(startDate, days) {
	let currentDate = new Date(startDate);
	let businessDaysAdded = 0;

	while (businessDaysAdded < days) {
		currentDate.setDate(currentDate.getDate() + 1);
		// Si c'est un jour ouvré (lundi = 1, vendredi = 5)
		if (currentDate.getDay() >= 1 && currentDate.getDay() <= 5) {
			businessDaysAdded++;
		}
	}

	return currentDate;
}

// Fonction pour formater une date en français (format court)
function formatDateInFrench(date) {
	const day = date.getDate();
	const month = MONTHS_SHORT[date.getMonth()];
	return `${day} ${month}`;
}

// Fonction pour formater une plage de dates
function formatDateRange(startDate, endDate) {
	const startDay = startDate.getDate();
	const endDay = endDate.getDate();

	// Si même mois
	if (startDate.getMonth() === endDate.getMonth()) {
		const month = MONTHS_SHORT[startDate.getMonth()];
		return `${startDay} - ${endDay} ${month}`;
	} else {
		// Si mois différents
		const startMonth = MONTHS_SHORT[startDate.getMonth()];
		const endMonth = MONTHS_SHORT[endDate.getMonth()];
		return `${startDay} ${startMonth} - ${endDay} ${endMonth}`;
	}
}

// Fonction utilitaire pour mettre à jour l'estimation d'un type de livraison
function updateEstimationForElements(elements, today) {
	elements.forEach(function (element) {
		const daysRange = element.getAttribute("data-days-range");
		if (daysRange) {
			const [minDays, maxDays] = daysRange.split("-").map((d) => parseInt(d.trim()));
			const minDate = calculateBusinessDays(today, minDays);
			const maxDate = calculateBusinessDays(today, maxDays);
			element.textContent = `Est. ${formatDateRange(minDate, maxDate)}`;
		}
	});
}

// Fonction pour calculer et afficher l'estimation de livraison
function updateDeliveryEstimation() {
	const today = new Date();

	// Mettre à jour les estimations pour tous les types de livraison
	updateEstimationForElements(document.querySelectorAll(".mm-estimation-days-home"), today);
	updateEstimationForElements(document.querySelectorAll(".mm-estimation-days-relay"), today);
}

// Initialisation du carrousel Splide pour la réassurance mobile
document.addEventListener("DOMContentLoaded", function () {
	const reassuranceSplide = document.getElementById("reassurance-splide");
	if (reassuranceSplide && window.Splide) {
		new Splide("#reassurance-splide", {
			type: "loop",
			perPage: 1,
			perMove: 1,
			pagination: true,
			arrows: false,
			autoplay: true,
			interval: 4000,
			pauseOnHover: true,
			pauseOnFocus: true,
			gap: "0px",
			padding: "0px",
			classes: {
				pagination: "splide__pagination mm-splide-pagination",
				page: "splide__pagination__page mm-splide-page",
			},
		}).mount();
	}
});

/*********************************************************************************************
 * Add a product with upsell to the cart.
 *
 * @param {number} parentVariantId - The ID of the parent variant.
 * @param {number} upsellVariantId - The ID of the upsell variant.
 * @param {Object} options - The options for adding the product.
 * @param {number} [options.parent_quantity=1] - The quantity of the parent product.
 * @param {boolean} [options.openCart=true] - Whether to open the cart drawer after adding the product.
 * @returns {Promise<Object>} - A promise resolving to the response data.
 */
//function mmAddProductWithUpsellToCart(parentVariantId, upsellVariantId, { parent_quantity = 1, openCart = true }) {
	//mmAPIRequest("POST", "cart/add.js", {
		//items: [
			//{
			//	id: parentVariantId,
			//	quantity: parent_quantity,
			//},
			//{
			//	id: upsellVariantId,
			//	quantity: 1,
			//	properties: {
			//		_parent_product: parentVariantId,
			//	},
			//},
		//],
		//sections: mmCartSectionId(),
	//})
	//	.then(refreshCartFromData)
	//	.then((data) => {
	//		if (openCart) {
	//			setTimeout(mmOpenCart);
	//		}
	//	})
	//	.catch((error) => {
	//		handleCartError(error, "Erreur lors de l'ajout du produit avec upsell:");
	//		mmOpenCart();
	//	});
//}

/*********************************************************************************************
 * Add a product to the cart.
 *
 * @param {number} variantId - The variant ID to add.
 * @param {Object} options - The options for adding the product.
 * @param {number} [options.quantity=1] - The quantity to add.
 * @param {boolean} [options.openCart=true] - Whether to open the cart after adding.
 * @returns {Promise<Object>} - A promise resolving to the response data.
 */
function mmAddProductToCart(variantId, { quantity = 1, openCart = true } = {}) {
	return mmAPIRequest("POST", "cart/add.js", {
		id: variantId,
		quantity: quantity,
		sections: mmCartSectionId(),
	})
		.then(refreshCartFromData)
		.then((data) => {
			if (openCart) {
				setTimeout(mmOpenCart);
			}
			return data;
		})
		.catch((error) => {
			handleCartError(error, "Erreur lors de l'ajout du produit:");
		});
}

/*********************************************************************************************
 * Add a product to the cart from the product form.
 *
 * @returns {void}
 */
// function mmAddProductToCartFromProductFrom() {
	// 1: on regarde si la checkbox de cross-sell existe, si oui on regarde si elle est checked

	//const upsellMetafieldElement = document.getElementById("upsell-metafield");

	// Si l'élément existe, vérifier le dataset
	//if (upsellMetafieldElement && upsellMetafieldElement.dataset.upsell) {
		// Récupérer la valeur du metafield upsell
	//	const upsellMetafield = upsellMetafieldElement.dataset.upsell;
		//console.log("Le metafield product_upsell n'est pas vide:", upsellMetafield);

		// Logique d'ajout au panier
		//const checkbox = document.querySelector(".mm-product-form .mm-check-upsell");
		//const variant_id = document.getElementById("product_id").value;

		//if (checkbox) {
			//if (checkbox.checked) {
			//	const upsell_variant_id = checkbox.dataset.variantId;
			//	mmAddProductWithUpsellToCart(variant_id, upsell_variant_id, { parent_quantity: variant_quantity, openCart: true });
			//} else {
				//const checkbox = document.querySelector(".mm-product-form .mm-check-upsell");
				//const variant_id = document.getElementById("product_id").value;
				//mmAddProductToCart(variant_id, { quantity: variant_quantity.value, openCart: true });
			//}
	//	}
	//} else {
		//const checkbox = document.querySelector(".mm-product-form .mm-check-upsell");
		//const variant_id = document.getElementById("product_id").value;

		//console.log("variant", variant_id);

		//mmAddProductToCart(variant_id, { quantity: variant_quantity.value, openCart: true });
	//}
//}

/*********************************************************************************************
 * Creates a debounced function that delays invoking func until after duration milliseconds have elapsed since the last time the debounced function was invoked.
 *
 * @param {Function} func - The function to debounce.
 * @param {number} duration - The number of milliseconds to delay.
 * @returns {Function} - The debounced function.
 */
function debounce(func, duration) {
	let timeout;
	return function (...args) {
		const effect = () => {
			timeout = null;
			return func.apply(this, args);
		};
		clearTimeout(timeout);
		timeout = setTimeout(effect, duration);
	};
}

/*********************************************************************************************
 * Get the full cart section ID from the DOM.
 *
 * @returns {HTMLElement} - The full cart section ID with the prefix.
 */
function mmCartSectionIdLong() {
	return document.querySelector(".mm-cart").id;
}

/*********************************************************************************************
 * Get the cart section ID from the DOM, removing the "shopify-section-" prefix.
 *
 * @returns {HTMLElement} - The cart section ID without the "shopify-section-" prefix.
 */
function mmCartSectionId() {
	const cartElement = document.querySelector(".mm-cart");
	if (!cartElement || !cartElement.id) {
		console.warn("mmCartSectionId: Élément .mm-cart non trouvé ou sans ID");
		return "mm-cart"; // Valeur par défaut
	}
	return cartElement.id.replace("shopify-section-", "");
}

/*********************************************************************************************
 * Get the cart section element from the DOM.
 *
 * @returns {HTMLElement} - The cart section element.
 */
function mmCartSectionElement() {
	return document.getElementById(`${mmCartSectionIdLong()}`);
}

/*********************************************************************************************
 * Get the cart product container element from the cart section.
 *
 * @returns {HTMLElement} - The cart product container element.
 */
function mmCartProductsContainerElement() {
	return mmCartSectionElement().querySelector(".mm-dc-products-container");
}

/*********************************************************************************************
 * Get the cart item element for a specific product variant.
 *
 * @param {number} line_index - The line item index.
 * @returns {HTMLElement} - The cart item element.
 */
function mmCartItem(line_index) {
	return mmCartProductsContainerElement().querySelector(`[data-line-index="${line_index}"]`);
}

/*********************************************************************************************
 * Get the cart item quantity element for a specific product variant.
 *
 * @param {number} line_index - The line item index.
 * @returns {HTMLElement} - The cart item quantity element.
 */
function mmCartItemQuantityEl(line_index) {
	const itemEl = mmCartItem(line_index);
	return itemEl.querySelector("[data-item-quantity]");
}

/*********************************************************************************************
 * Get the quantity of a specific cart item.
 *
 * @param {number} line_index - The line item index.
 * @returns {number} - The quantity of the cart item.
 */
function mmGetCartItemQuantity(line_index) {
	const quantityEl = mmCartItemQuantityEl(line_index);
	return Number.parseInt(quantityEl.dataset.itemQuantity);
}

/*********************************************************************************************
 * Set the quantity of a specific cart item and update the DOM.
 *
 * @param {number} line_index - The line item index.
 * @param {number} newQuantity - The new quantity to set.
 */
function mmSetCartItemQuantity(line_index, newQuantity) {
	// Display quantity in front
	if (newQuantity >= 0) {
		const quantityEl = mmCartItemQuantityEl(line_index);
		quantityEl.dataset.itemQuantity = newQuantity;
		quantityEl.innerText = newQuantity;
	}
}

/*********************************************************************************************
 * Create a new cart element from the provided data.
 *
 * @param {Object} data - The data containing cart HTML.
 * @returns {HTMLElement} - The new cart element.
 */
function mmCartHTMLFromData(data) {
	const el = document.createElement("DIV");
	el.innerHTML = data.sections["mm-cart"];
	return el;
}

/*********************************************************************************************
 * Extract the items container from the new cart HTML.
 *
 * @param {Object} data - The data containing cart HTML.
 * @returns {HTMLElement} - The items container element.
 */
function extractItemsFromCartHTML(data) {
	const el = mmCartHTMLFromData(data);
	return el.querySelector(".mm-dc-products-container");
}

/*********************************************************************************************
 * Insert cart products from the response data into the current cart in the DOM.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 */
function insertCartProductsFromResponse(data) {
	const itemsContainer = extractItemsFromCartHTML(data);
	mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;
	return data;
}

/*********************************************************************************************
 * Extract the total price element from the new cart HTML.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {HTMLElement} - The total price element.
 */
function extractTotalPriceFromCartHTML(data) {
	const cartEl = mmCartHTMLFromData(data);
	return cartEl.querySelector("[data-cart-total-price]");
}

/*********************************************************************************************
 * Insert the total price from the response data into the current cart in the DOM.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 */
function insertInsertTotalPriceFromResponse(data) {
	const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
	const currentTotalPriceEl = mmCartSectionElement().querySelector("[data-cart-total-price]");
	currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;
	return data;
}

/*********************************************************************************************
 * Perform an API request to fetch or update cart data.
 *
 * @param {string} method - The HTTP method (GET, POST, etc.).
 * @param {string} path - The API endpoint path.
 * @param {Object} body - The request body data.
 * @returns {Promise<Object>} - A promise resolving to the response data.
 */
function mmAPIRequest(method, path, body) {
	document.querySelector(".mm-dc-products")?.classList?.add("mm-inactive");
	return fetch(window.Shopify.routes.root + path, {
		method: method,
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(body),
	})
		.then((response) => response.json())
		.then((data) => {
			// mmLog(data);
			document.querySelector(".mm-dc-products")?.classList?.remove("mm-inactive");
			updateCartCount(data.item_count != null ? data.item_count : 0);
			if (data.status && data.status > 400) {
				throw data;
			} else {
				return data;
			}
		});
}

/*********************************************************************************************
 * Fetch the current cart data.
 *
 * @returns {Promise<Object>} - A promise resolving to the cart data.
 */
function mmGetCart() {
	return mmAPIRequest("GET", "cart.js");
}

/*********************************************************************************************
 * Open the cart drawer and fetch the latest cart data.
 */
function mmOpenCart() {
	mmGetCart();
	const cartFilter = document.querySelector(".mm-drawer-cart-wrapper");
	const html = document.querySelector("html");

	if (!cartFilter || !html) return;

	cartFilter.classList.add("mm-dc-is-open");
	html.classList.add("stop-scrolling");

	loadCartCrossSell();

	document.getElementById("shopify-chat").style.display = "none";
	document.getElementById("axeptio_overlay").style.display = "none";
}

/*********************************************************************************************
 * Close the cart drawer and allow page scrolling.
 *
 */
function mmCloseCart() {
	document.querySelector(".mm-drawer-cart-wrapper").classList.remove("mm-dc-is-open");
	document.querySelector("html").classList.remove("stop-scrolling");
}

/*********************************************************************************************
 * Re-render the cart inner HTML from the response data and initialize Splide carousels.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 */
function refreshCartFromData(data) {
	const newCartEl = document.createElement("DIV");
	newCartEl.innerHTML = data.sections[mmCartSectionId()];
	const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart");
	innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart").innerHTML;
	// mmInitSplideRea();
	// mmInitSplideCross();

	// Réinitialiser les event listeners après le refresh
	setTimeout(() => {
		if (typeof window.initializeDeliveryProgressBar === "function") {
			window.initializeDeliveryProgressBar();
		}

		// Réinitialiser les event listeners pour les options de livraison
		if (typeof initializeDeliveryEventListeners === "function") {
			initializeDeliveryEventListeners();
		}

		// Mettre à jour les données du panier et la progress bar après le refresh
		updateCartDataInDOM();
	}, 300);

	return data;
}

/*********************************************************************************************
 * Sets up the cart form submission handler.
 */
function mmSetupProductForm() {
	const forms = document.querySelectorAll("[data-type='add-to-cart-form']");
	if (!forms) return;

	forms.forEach((form) => {
		form.addEventListener("submit", function (event) {
			event.preventDefault();

			const formData = new FormData(form);

			fetch("/cart/add.js", {
				method: "POST",
				body: formData,
			})
				.then((response) => response.json())
				.then((data) => {
					console.log("Produit ajouté:", data);
					mmOpenAndRefreshCart();
                         updateCartCount();
				})
				.catch((error) => {
					console.error("Erreur:", error);
				});
		});
	});
}

/*********************************************************************************************
 * Refresh the cart and open the cart drawer
 */
function mmOpenAndRefreshCart() {
	function handleResponse() {
		const newCartEl = document.createElement("DIV");
		newCartEl.innerHTML = this.responseText;
		const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart");
		innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart").innerHTML;

		mmOpenCart();
	}
	const request = new XMLHttpRequest();
	request.addEventListener("load", handleResponse);
	request.open("GET", `/?section_id=${mmCartSectionId()}`, true);
	request.send();
}

/*********************************************************************************************
 * Increase the quantity of a specific product in the cart by one.
 *
 * @param {number} line_index - The line item index.
 */
function mmIncreaseProductQuantity(line_index) {
	const itemCart = mmCartItem(line_index);
	const quantity = mmGetCartItemQuantity(line_index);
	const maxQtty = parseInt(itemCart.dataset.maxQuantity, 10);
	const newQuantity = quantity + 1;

	if (newQuantity > maxQtty) {
		return;
	}

	mmSetCartItemQuantity(line_index, newQuantity);
	mmDebouncedPushNewQuantity(line_index);
}

/*********************************************************************************************
 * Decrease the quantity of a specific product in the cart by one.
 *
 * @param {number} line_index - The line item index.
 */
function mmDecreaseProductQuantity(line_index) {
	const itemCart = mmCartItem(line_index);
	const quantity = mmGetCartItemQuantity(line_index);
	const maxQtty = parseInt(itemCart.dataset.maxQuantity, 10);
	const newQuantity = quantity - 1;

	if (newQuantity > maxQtty) {
		return;
	}

	mmSetCartItemQuantity(line_index, newQuantity);
	mmDebouncedPushNewQuantity(line_index);
}

/*********************************************************************************************
 * Remove a specific product from the cart.
 *
 * @param {number} line_index - The line item index.
 */
function mmDestroyProductFromCart(line_index) {
	const newQuantity = 0;
	mmSetCartItemQuantity(line_index, newQuantity);
	mmDebouncedPushNewQuantity(line_index);
}

/*********************************************************************************************
 * Push the new quantity of a specific product to the server.
 *
 * @param {number} line_index - The line item index.
 */
function mmPushNewQuantity(line_index) {
	const quantity = mmGetCartItemQuantity(line_index);
	mmAPIRequest("POST", "cart/change.js", {
		line: line_index,
		quantity: quantity,
		sections: mmCartSectionId(),
	})
		.then(mmAddOrRemoveFreeProducts)
		.then(refreshCartFromData)
		.then((data) => {})
		.catch((error) => {
			handleCartError(error, "Erreur lors de la mise à jour du panier:");
		});
}

/*********************************************************************************************
 * Remove a line item from the cart.
 *
 * @param {number|string} line_index - The index of the line item in the cart to be removed.
 */
function mmDestroyLineItemFromCart(line_index) {
	mmAPIRequest("POST", "cart/change.js", {
		line: parseInt(line_index),
		quantity: 0,
		sections: mmCartSectionId(),
	}).then(refreshCartFromData);
}

/*********************************************************************************************
 * Debounced function to push new quantity of a specific product to the server.
 *
 * @param {number} line_index - The line item index.
 */
const mmDebouncedPushNewQuantity = debounce(function (line_index, maxQtty) {
	const quantity = mmGetCartItemQuantity(line_index);

	if (quantity > maxQtty) {
		return;
	}
	mmPushNewQuantity(line_index);
}, 300);

/*********************************************************************************************
 * Update the cart count bubble with the given value.
 *
 * @param {number} value - The new cart count value.
 */
function updateCartCount(value) {
	// Mettre à jour le compteur du panier dans le drawer
	const cartCountBubble = document.querySelector(".mm-cart-count-bubble");
	if (cartCountBubble) {
		if (value > 0) {
			cartCountBubble.classList.remove("mm-none");
			cartCountBubble.innerText = value;
		} else {
			cartCountBubble.classList.add("mm-none");
		}
	}

	// Mettre à jour le compteur du panier dans le header
	const headerCartCount = document.querySelector("#js-header-cart-count");
	if (headerCartCount) {
		if (value > 0) {
			headerCartCount.innerText = value;
			headerCartCount.style.display = "block";
		}
	}

	// Mettre à jour les données du panier et la progress bar
	setTimeout(() => {
		updateCartDataInDOM();
	}, 200);
}

/*********************************************************************************************
 * Add or remove free products from the cart based on conditions.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 */
function mmAddOrRemoveFreeProducts(data) {
	if (data.sections["mm-cart"]) {
		const el = mmCartHTMLFromData(data);
		const freeProductEls = el.querySelector("[data-free-products]");
		let freeProductCounts = 0;

		// creates an object like { 44058675: 1, 44058001: 0 }
		// where key is free product id and value, its quantity
		const productsParams = Array.from(freeProductEls.children).reduce((param, freeProductEl) => {
			const productId = freeProductEl.dataset.variantId;
			const isFree = freeProductEl.dataset.freeProduct == "true";
			const itemEl = mmCartItem(productId);
			if (isFree) {
				freeProductCounts += 1;
			}
			if (itemEl && isFree) {
				console.log("do nothing, item is already added");
				// do nothing, item is already added
			} else if (itemEl && !isFree) {
				console.log("item is present but should be removed");
				// item is present but should be removed
				param[productId] = 0;
			} else if (!itemEl && isFree) {
				console.log("item is absent but should be added", productId);
				// item is absent but should be added
				param[productId] = 1;
			}
			return param;
		}, {});

		// Add or remove free products only if needed
		if (Object.keys(productsParams).length > 0) {
			console.log("productsParams", productsParams);
			mmAPIRequest("POST", "cart/update.js", { updates: productsParams, sections: mmCartSectionId() }).then(refreshCartFromData);
		}
	}
	return data;
}

/*********************************************************************************************
 * Add a free product to the cart and optionally open the cart drawer.
 *
 * @param {number} productId - The free product ID to add.
 * @param {Object} options - Options for adding the product.
 * @param {number} [options.quantity=1] - The quantity to add.
 * @param {boolean} [options.openCart=true] - Whether to open the cart drawer after adding the product.
 * @param {HTMLElement} clickedElem - The element that was clicked to trigger this action.
 */
function mmAddFreeProductToCart(productId, { quantity = 1, openCart = true }, clickedElem) {
	// Debounce on the CTA
	clickedElem.innerText = "AJOUTÉ !";
	clickedElem.classList.add("mm-disabled");

	// Ajouter le free product
	mmAddProductToCart(productId, { openCart: false });
}

// DISCOUNT CODE
function removeDiscount() {
	fetch(window.Shopify.routes.root + "cart/update.js", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({ discount: "" }),
	})
		.then((res) => res.json())
		.then((data) => {
			window.location.reload();
		})
		.catch((err) => {
			console.error("Erreur lors du retrait du code promo :", err);
			alert("Erreur lors du retrait du code promotionnel.");
		});
}

async function mmApplyDiscountInCart() {
	const codeInput = document.getElementById("discount-code");
	const newCode = codeInput.value.trim().toLowerCase();
	const errorMessageText = codeInput.dataset.errorText;
	if (!newCode) return;

	// 1. Récupérer tous les codes déjà appliqués
	let previousCodes = [];
	try {
		const cartBefore = await fetch("/cart.js").then((r) => r.json());
		// on ne garde que ceux applicables
		previousCodes = cartBefore.discount_codes.filter((d) => d.applicable).map((d) => d.code.toLowerCase());
	} catch (err) {
		console.error("Impossible de récupérer les codes existants", err);
	}

	// 2. Ajouter le produit lié si besoin (comme avant)
	const hiddenInputs = document.querySelectorAll(".mm-hgjfidu");
	let matchedVariantId = null;
	hiddenInputs.forEach((input) => {
		if (atob(input.value).toLowerCase() === newCode) {
			matchedVariantId = input.dataset.variantId;
		}
	});
	if (matchedVariantId) {
		try {
			await fetch(window.Shopify.routes.root + "cart/add.js", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ id: matchedVariantId, quantity: 1 }),
			}).then((r) => r.json());
		} catch (err) {
			console.error("Erreur ajout produit promo", err);
		}
	}

	// 3. Composer la liste complète de codes à appliquer
	const allCodes = Array.from(new Set([...previousCodes, newCode]));
	const discountString = allCodes.join(",");

	// 4. Tenter d’appliquer tous les codes
	try {
		await fetch(window.Shopify.routes.root + "cart/update.js", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ discount: discountString }),
		});

		// 5. Vérifier si le nouveau code a été appliqué
		const cartAfter = await fetch("/cart.js").then((r) => r.json());
		const appliedCodes = cartAfter.discount_codes.map((d) => ({
			code: d.code.toLowerCase(),
			ok: d.applicable,
		}));
		const newCodeResult = appliedCodes.find((d) => d.code === newCode);

		if (newCodeResult && newCodeResult.ok) {
			// succès : rafraîchir la page pour mettre à jour la progress bar
			window.location.reload();
		} else {
			// échec pour le nouveau code
			displayPromoError(errorMessageText);

			// 6. Réappliquer **seulement** les anciens codes
			if (previousCodes.length) {
				await fetch(window.Shopify.routes.root + "cart/update.js", {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ discount: previousCodes.join(",") }),
				});
			}
		}
	} catch (err) {
		console.error("Erreur lors de l’application des codes promo", err);
		displayPromoError("Une erreur est survenue. Veuillez réessayer.");
		// on ne touche pas aux codes déjà en place
	}
}

// Affiche un message d’erreur sous le formulaire
function displayPromoError(message) {
	let errorElem = document.querySelector(".promo-error");
	if (!errorElem) {
		errorElem = document.createElement("div");
		errorElem.className = "promo-error text-xs text-red-600 mt-2";
		const form = document.getElementById("discount-form") || document.body;
		form.appendChild(errorElem);
	}
	errorElem.textContent = message;
}

/*********************************************************************************************
 * Gestion des options de livraison dans le panier
 *
 */

// Fonction pour gérer les options de click & collect (Mondial Relay)
function handleCCOption() {
	// Vérifier si le widget Mondial Relay est disponible
	if ($("#container-zonewidget").length === 0) {
		console.warn("Widget Mondial Relay non disponible - point relais non configuré");
		return;
	}

	if (typeof $ === "undefined") {
		console.error("jQuery is not loaded");
		return;
	}

	setTimeout(function () {
		$("#button-add").show();
		$(".relay_note").show();
	}, 1500);
	$("#zonewidget .container").trigger("MR_RebindMap");

	$("#storeInfo").val();

	$.magnificPopup.open({
		items: {
			src: "#container-zonewidget",
		},
		type: "inline",
		mainClass: "modal_zonewidget mfp-fade",
		removalDelay: 300,
	});

	$("#button-add")
		.off("click")
		.on("click", function () {
			$.magnificPopup.close();
			$("#container-zonewidget").css("display", "none");
		});

	$("#zonewidget").MR_ParcelShopPicker({
		Target: "#Retour_Widget",
		Brand: "F1L4COOK",
		NbResults: "10",
		Country: "FR",
		AllowedCountries: "FR",
		PostCode: "75001",
		EnableGeolocalisatedSearch: "true",
		ColLivMod: "24R",
		Responsive: true,
		OnParcelShopSelected: function (data) {
			// console.log("=== POINT RELAIS SÉLECTIONNÉ ===");
			// console.log("Données reçues:", data);

			$("#storeInfo").val(JSON.stringify(data));
			$(".store_pick_addr").empty();

			// Formater correctement l'adresse avec les espaces
			var store_addr = data.Adresse1;
			if (data.Adresse2) {
				store_addr += " " + data.Adresse2;
			}

			// console.log("Adresse formatée:", store_addr);

			$(".store_pick_addr").prepend('<div class="nom">' + data.Nom + '</div><div class="addr">' + store_addr + '</div><div class="city_zip">' + data.CP + " - " + data.Ville + "</div>");
			$(document).on("click", "#zonewidget .PR-List-Item", function () {
				$("#zonewidget .remodal-confirm").removeClass("hide");
			});
			$("#homeDelivery").val("NA");

			// Sauvegarder la sélection après avoir configuré le point relais
			saveDeliverySelection();

			// console.log("Données stockées dans storeInfo:", $("#storeInfo").val());
			// console.log("================================");
		},
	});
}

// Fonctions d'aide pour la gestion des erreurs
function hideErrorForStorePickup() {
	$(".main-cart__error").remove();
	$(".delivery_field").removeClass("delivery_field_error");
	$("#storePickup").removeClass("delivery_field_error");
}

function hideErrorForShippingMethod() {
	$(".main-cart__error").remove();
	$(".delivery_field").removeClass("delivery_field_error");
	$("#homeDelivery").removeClass("delivery_field_error");
}

// Fonction pour la progress bar - utilise initializeDeliveryProgressBar
function updateProgressBarForDelivery() {
	// Attendre un peu que initializeDeliveryProgressBar soit disponible
	setTimeout(() => {
		if (typeof window.initializeDeliveryProgressBar === "function") {
			window.initializeDeliveryProgressBar();
		}
	}, 10);
}

/*********************************************************************************************
 * Event handlers pour les options de livraison
 *
 */

function handleDeliveryOptionChange(e) {
	var $current = $(this);
	// Prevent selecting disabled store pickup radio
	if ($current.is("#storePickupRadio") && $current.is(':disabled')) {
		e.preventDefault();
		e.stopPropagation();
		return false;
	}
	e.preventDefault();
	e.stopPropagation();

	// Cocher le radio button sélectionné
	$("input", $current).prop("checked", true);

	// Gérer les classes active
	$("#custom-delivery-methods label").removeClass("active");
	$current.addClass("active");

	// Masquer tous les détails de livraison
	$("#custom-delivery-methods").find(".deliveryDetails").hide();

	// Afficher les détails de l'option sélectionnée
	// Rechercher le .deliveryDetails dans le même li que le label cliqué
	var $deliveryDetails = $current.closest("li").find(".deliveryDetails");
	$deliveryDetails.show();

	if ($current.is("#homeDeliveryRadio")) {
		$("#storeInfo").val("NA");
		$(".store_pick_addr").empty();
		$("#homeDelivery").val("homeDelivery");
		// console.log("Livraison à domicile sélectionnée - storeInfo: NA, homeDelivery: homeDelivery");
	} else if ($current.is("#storePickupRadio")) {
		$("#homeDelivery").val("NA");
		// console.log("Point relais sélectionné - homeDelivery: NA, storeInfo:", $("#storeInfo").val());
	}

	// Sauvegarder la sélection
	saveDeliverySelection();

	hideErrorForStorePickup();
	hideErrorForShippingMethod();

	// Mettre à jour la progress bar immédiatement après changement d'option
	setTimeout(() => {
		console.log("Updating progress bar after delivery option change");
		if (typeof window.initializeDeliveryProgressBar === "function") {
			window.initializeDeliveryProgressBar();
		}
		if (typeof updateProgressBarForDelivery === "function") {
			updateProgressBarForDelivery();
		}
	}, 50);
}

function handleRelayLinkClick(e) {
	e.preventDefault();
	// Check if store pickup is disabled due to weight restrictions
	const storePickupRadio = document.getElementById("storePickupRadio");
	if (storePickupRadio && storePickupRadio.disabled) {
		return false;
	}
	handleCCOption();
	hideErrorForStorePickup();
}

function handleCheckoutClick(e) {
	// NE PAS EMPÊCHER LA SOUMISSION NATURELLE DU FORMULAIRE
	// e.preventDefault();

	// Vérifier les conditions mais laisser le formulaire se soumettre naturellement
	if (!$("#agree").is(":checked")) {
		console.log("Erreur: Conditions générales non acceptées");
		$(".t-and-c-error").show();
		e.preventDefault();
		return false;
	}

	// if (!$('input[name="delivery"]').is(":checked") && $("#containStandardProduct").val() !== "false") {
	// 	console.log("Erreur: Aucune option de livraison sélectionnée");
	// 	$(".shipping-not-selected-error").show();
	// 	e.preventDefault();
	// 	return false;
	// }

	// if ($("#storePickupRadio").is(":checked") && ($("#storeInfo").val() == "" || $("#storeInfo").val() == "NA")) {
	// 	console.log("Erreur: Point relais sélectionné mais pas configuré");
	// 	$(".store-pickup-error").show();
	// 	e.preventDefault();
	// 	return false;
	// }

	console.log("Toutes les validations passées - soumission du formulaire...");
	// Laisser le formulaire se soumettre naturellement
	return true;
}

// Fonction pour soumettre le formulaire de panier avec les données de livraison
function submitCartForm() {

	// Décoder et afficher les données du point relais si elles existent
	const storeInfoValue = $("#storeInfo").val();
	if (storeInfoValue && storeInfoValue !== "NA" && storeInfoValue !== "") {
		try {
			const storeData = JSON.parse(storeInfoValue);
			console.log("Détails du point relais à transmettre:");
			console.log("  - Nom:", storeData.Nom);
			console.log("  - Adresse1:", storeData.Adresse1);
			console.log("  - Adresse2:", storeData.Adresse2);
			console.log("  - CP:", storeData.CP);
			console.log("  - Ville:", storeData.Ville);
		} catch (e) {
			console.error("Erreur lors du décodage des données du point relais:", e);
		}
	}

	// Trouver le formulaire de panier
	const cartForm = document.getElementById("cart");
	if (cartForm) {
		// Vérifier que les champs cachés sont bien dans le formulaire
		const storeInfoField = cartForm.querySelector("#storeInfo");
		const homeDeliveryField = cartForm.querySelector("#homeDelivery");
		const colissimoField = cartForm.querySelector("#colissimoDelivery");
		const containStandardField = cartForm.querySelector("#containStandardProduct");

		console.log("Vérification des champs dans le formulaire:");
		console.log("  - storeInfo:", storeInfoField ? "PRÉSENT ✓" : "ABSENT ✗");
		console.log("  - homeDelivery:", homeDeliveryField ? "PRÉSENT ✓" : "ABSENT ✗");
		console.log("  - colissimoDelivery:", colissimoField ? "PRÉSENT ✓" : "ABSENT ✗");
		console.log("  - containStandardProduct:", containStandardField ? "PRÉSENT ✓" : "ABSENT ✗");

		if (storeInfoField && homeDeliveryField) {
			console.log("Formulaire trouvé avec tous les champs, soumission en cours...");
			// Soumettre le formulaire - cela enverra toutes les données cachées au checkout
			cartForm.submit();
		} else {
			console.error("Champs cachés manquants dans le formulaire!");
			console.log("Tentative de redirection fallback...");
			redirectToCheckout();
		}
	} else {
		console.error("Formulaire de panier non trouvé, redirection fallback");
		// Fallback vers redirection simple
		redirectToCheckout();
	}

}

// Fonction pour rediriger vers le checkout (fallback)
function redirectToCheckout() {
	// Utiliser window.Shopify.routes pour une meilleure compatibilité
	const checkoutUrl = window.Shopify?.routes?.root + "checkout" || "/checkout";
	window.location.href = checkoutUrl;
}

function handleAgreeChange() {
	if (this.checked) {
		$(".t-and-c-error").hide();
	}
}

/*********************************************************************************************
 * Fonctions pour sauvegarder et restaurer la sélection de livraison
 *
 */

// Sauvegarder la sélection de livraison actuelle
function saveDeliverySelection() {
	const selectedOption = document.querySelector('input[name="delivery"]:checked');
	if (selectedOption) {
		sessionStorage.setItem('mm_delivery_selection', selectedOption.id);
		console.log('Sélection de livraison sauvegardée:', selectedOption.id);
		return true;
	} else {
		console.log('Aucune option de livraison sélectionnée pour la sauvegarde');
		return false;
	}
}

// Restaurer la sélection de livraison sauvegardée
function restoreDeliverySelection() {
	const savedSelection = sessionStorage.getItem('mm_delivery_selection');
	console.log('Tentative de restauration de la sélection:', savedSelection);

	if (savedSelection) {
		const optionElement = document.getElementById(savedSelection);
		// console.log('Élément trouvé:', optionElement);

		if (optionElement) {
			// Décocher toutes les options d'abord (JavaScript vanilla)
			const allDeliveryInputs = document.querySelectorAll('input[name="delivery"]');
			allDeliveryInputs.forEach(input => {
				input.checked = false;
			});

			// Retirer la classe active de tous les labels
			const allLabels = document.querySelectorAll('#custom-delivery-methods label');
			allLabels.forEach(label => {
				label.classList.remove('active');
			});

			// Cocher l'option sauvegardée
			optionElement.checked = true;
			const labelElement = optionElement.closest('label');
			if (labelElement) {
				labelElement.classList.add('active');
			}

			// Mettre à jour les valeurs des champs cachés
			const homeDeliveryField = document.getElementById('homeDelivery');
			const storeInfoField = document.getElementById('storeInfo');

			if (savedSelection === "homeDeliveryRadio") {
				if (homeDeliveryField) homeDeliveryField.value = "homeDelivery";
				if (storeInfoField) storeInfoField.value = "NA";
			} else if (savedSelection === "storePickupRadio") {
				if (homeDeliveryField) homeDeliveryField.value = "NA";
				// Ne pas réinitialiser storeInfo si on avait déjà un point relais sélectionné
				if (storeInfoField && (storeInfoField.value === "" || storeInfoField.value === null)) {
					storeInfoField.value = "NA";
				}
			}

			// Afficher les détails de l'option sélectionnée
			const allDeliveryDetails = document.querySelectorAll('#custom-delivery-methods .deliveryDetails');
			allDeliveryDetails.forEach(detail => {
				detail.style.display = 'none';
			});

			const selectedDetails = optionElement.closest('li')?.querySelector('.deliveryDetails');
			if (selectedDetails) {
				selectedDetails.style.display = 'block';
			}

			console.log('Sélection de livraison restaurée avec succès:', savedSelection);
			return true;
		} else {
			// console.log('Élément non trouvé dans le DOM:', savedSelection);
		}
	}
	return false;
}

/*********************************************************************************************
 * Initialisation des event listeners pour les options de livraison
 *
 */
function initializeDeliveryEventListeners() {
	// console.log("=== INITIALISATION EVENT LISTENERS ===");

	// Détacher d'abord les anciens event listeners pour éviter les doublons
	// $('input[name="delivery"]').off("change.delivery");
	// $("#clickAndCollectButton").off("click.delivery");
	$("#checkout").off("click.delivery");
	$("#agree").off("change.delivery");
	// $(".relay_link").off("click.delivery");

	// Attacher les nouveaux event listeners avec namespace
	// $('input[name="delivery"]').on("change.delivery", handleDeliveryOptionChange);
	// $("#clickAndCollectButton").on("click.delivery", handleRelayLinkClick);
	$("#checkout").on("click.delivery", handleCheckoutClick);
	$("#agree").on("change.delivery", handleAgreeChange);
	// $(".relay_link").on("click.delivery", handleRelayLinkClick);

	// Essayer de restaurer la sélection sauvegardée avec un délai pour s'assurer que le DOM est prêt
	// setTimeout(() => {
	// 	const restored = restoreDeliverySelection();

	// 	if (!restored) {
	// 		// Si aucune sélection sauvegardée, initialiser les valeurs par défaut
	// 		$("#storeInfo").val("NA");
	// 		$('input[name="delivery"]').prop("checked", false);

	// 		// Sélectionner par défaut : point relais si disponible, sinon livraison à domicile
	// 		if ($("#storePickupRadio").length > 0) {
	// 			// Point relais disponible - le sélectionner par défaut
	// 			$("#storePickupRadio").prop("checked", true);
	// 			$("#homeDelivery").val("NA");
	// 			// Ajouter la classe active pour le style
	// 			$("#storePickupRadio").closest("label").addClass("active");
	// 			$("#homeDeliveryRadio").closest("label").removeClass("active");
	// 			// Afficher les détails du point relais
	// 			$("#custom-delivery-methods").find(".deliveryDetails").hide();
	// 			$("#storePickupRadio").closest("li").find(".deliveryDetails").show();
	// 			console.log("Point relais sélectionné par défaut");
	// 		} else {
	// 			// Point relais non disponible - sélectionner livraison à domicile
	// 			$("#homeDeliveryRadio").prop("checked", true);
	// 			$("#homeDelivery").val("homeDelivery");
	// 			// Ajouter la classe active pour le style
	// 			$("#homeDeliveryRadio").closest("label").addClass("active");
	// 			// Afficher les détails de la livraison à domicile
	// 			$("#custom-delivery-methods").find(".deliveryDetails").hide();
	// 			$("#homeDeliveryRadio").closest("li").find(".deliveryDetails").show();
	// 			console.log("Livraison à domicile sélectionnée par défaut");
	// 		}
	// 	}
	// }, 200);

	hideErrorForStorePickup();
	hideErrorForShippingMethod();

	// Initialiser la progress bar après un délai pour laisser le DOM se charger
	setTimeout(() => {
		updateProgressBarForDelivery();
	}, 200);

	// Sauvegarder la sélection actuelle après l'initialisation
	// setTimeout(() => {
	// 	saveDeliverySelection();
	// }, 300);
}

/*********************************************************************************************
 * Loaded Listenner
 *
 */
window.addEventListener("DOMContentLoaded", () => {
	mmGetCart();

	// Mettre à jour les compteurs de panier au chargement
	setTimeout(() => {
		fetch('/cart.js')
			.then(response => response.json())
			.then(cart => {
				updateCartCount(cart.item_count);
			})
			.catch(error => {
				console.error('Erreur lors de la mise à jour des compteurs:', error);
			});
	}, 100);
});

document.addEventListener(
	"DOMContentLoaded",
	() => {
		// mmInitSplideRea();
		// mmInitSplideCross();
		// mmSetupProductForm(); // Désactivé car section-main-product.js gère les formulaires

		// Initialiser les event listeners pour les options de livraison
		// uniquement si on est sur une page avec ces éléments
		if (document.querySelector("#custom-delivery-methods") || document.querySelector(".mm-cart") || document.querySelector("#checkout")) {
			initializeDeliveryEventListeners();
		}
	},
	{ once: true }
);

/*********************************************************************************************
 * Gestion de la progress bar de livraison gratuite
 *
 */
function initializeDeliveryProgressBar() {
	// Calculer et afficher les estimations de livraison
	updateDeliveryEstimation();
	const homeDeliveryRadio = document.getElementById("homeDeliveryRadio");
	const storePickupRadio = document.getElementById("storePickupRadio");

	// Sélectionner tous les éléments par classe pour mobile et desktop
	const deliveryOptionTexts = document.querySelectorAll(".mm-delivery-option-text");
	const progressTexts = document.querySelectorAll(".mm-progress-text");

	// Fonction pour mettre à jour le texte et la progress bar
	function updateDeliveryOption(selectedOption) {
		// Récupérer les textes depuis les settings Liquid (injectés dans le DOM)
		const dataElement = document.querySelector("[data-delivery-text-home]");
		if (!dataElement) {
			console.warn("Données de livraison non trouvées dans le DOM");
			return;
		}

		const homeText = dataElement.dataset.deliveryTextHome || "Livraison offerte à domicile";
		const relayText = dataElement.dataset.deliveryTextRelay || "Livraison offerte en point relais";
		const homeThreshold = parseInt(dataElement.dataset.thresholdHome) || 7900;
		const relayThreshold = parseInt(dataElement.dataset.thresholdRelay) || 4900;

		const deliveryTexts = {
			home: homeText,
			relay: relayText,
		};

		const thresholds = {
			home: homeThreshold,
			relay: relayThreshold,
		};

		// Mettre à jour tous les textes d'option (mobile et desktop)
		deliveryOptionTexts.forEach(function (element) {
			element.textContent = deliveryTexts[selectedOption];
		});

		// Récupérer le total du panier depuis les éléments DOM mis à jour
		const cartTotal = parseInt(dataElement.dataset.cartTotalCents);

		const currentThreshold = thresholds[selectedOption];

		let progressTextContent = "";
		let percentage = 0;

		if (cartTotal >= currentThreshold) {
			progressTextContent = "";
			percentage = 100;
		} else {
			const remaining = Math.abs(currentThreshold - cartTotal);
			const remainingFormatted = (remaining / 100).toLocaleString("fr-FR", {
				style: "currency",
				currency: "EUR",
				minimumFractionDigits: 0,
				maximumFractionDigits: 2,
			});
			progressTextContent = `${remainingFormatted} restants`;
			percentage = Math.min((cartTotal / currentThreshold) * 100, 100);
		}

		// Mettre à jour tous les textes de progression (mobile et desktop)
		progressTexts.forEach(function (element) {
			element.textContent = progressTextContent;
		});

		// Mettre à jour les prix de livraison en fonction du seuil
		updateDeliveryPrices(selectedOption, cartTotal, currentThreshold);

		updateProgressBar(percentage);
	}

	// Fonction pour obtenir le texte "gratuit" selon la langue
	function getFreeText() {
		// Détecter la langue depuis l'attribut lang du HTML ou la locale
		const htmlLang = document.documentElement.lang || document.querySelector('html').getAttribute('lang');
		const isFrench = htmlLang && htmlLang.toLowerCase().startsWith('fr');

		// Vérifier aussi dans les classes du body ou autres indicateurs
		const bodyClasses = document.body.className.toLowerCase();
		const isFrenchFromBody = bodyClasses.includes('fr') || bodyClasses.includes('french');

		// Retourner le texte approprié
		return (isFrench || isFrenchFromBody) ? 'OFFERT' : 'FREE';
	}

	// Fonction pour mettre à jour les prix de livraison en fonction du seuil
	function updateDeliveryPrices(selectedOption, cartTotal, currentThreshold) {
		// Récupérer le total du panier depuis l'API Shopify (même source que {{ cart.total_price | money }})
		fetch('/cart.js')
			.then(response => response.json())
			.then(cart => {
				const actualCartTotal = cart.total_price;

				// Récupérer les éléments de prix de livraison
				const homeDeliveryPriceElements = Array.from(document.querySelectorAll('#homeDeliveryRadio')).map(radio =>
					radio.closest('label').querySelector('.cart__checkout-subtotal-label')
				).filter(Boolean);

				const relayDeliveryPriceElements = Array.from(document.querySelectorAll('#storePickupRadio')).map(radio =>
					radio.closest('label').querySelector('.cart__checkout-subtotal-label')
				).filter(Boolean);

				// Récupérer les prix de livraison depuis les settings
				const dataElement = document.querySelector("[data-delivery-text-home]");
				if (!dataElement) {
					console.warn("Données de livraison non trouvées pour les prix");
					return;
				}

				const homeThreshold = parseInt(dataElement.dataset.thresholdHome) || 7900;
				const relayThreshold = parseInt(dataElement.dataset.thresholdRelay) || 4900;

				// Obtenir le texte "gratuit" selon la langue
				const freeText = getFreeText();

				// Mettre à jour le prix de livraison à domicile
				homeDeliveryPriceElements.forEach(function(element) {
					if (element) {
						if (actualCartTotal >= homeThreshold) {
							element.textContent = freeText;
							element.style.color = "#28a745"; // Vert pour indiquer gratuit
							element.style.fontWeight = "bold";
						} else {
							// Récupérer le prix original depuis l'attribut data
							const originalPrice = element.dataset.originalPrice || "7.99";
							element.textContent = originalPrice + "€";
							element.style.color = ""; // Couleur par défaut
							element.style.fontWeight = ""; // Poids par défaut
						}
					}
				});

				// Mettre à jour le prix de livraison en point relais
				relayDeliveryPriceElements.forEach(function(element) {
					if (element) {
						if (actualCartTotal >= relayThreshold) {
							element.textContent = freeText;
							element.style.color = "#28a745"; // Vert pour indiquer gratuit
							element.style.fontWeight = "bold";
						} else {
							// Récupérer le prix original depuis l'attribut data
							const originalPrice = element.dataset.originalPrice || "5.99";
							element.textContent = originalPrice + "€";
							element.style.color = ""; // Couleur par défaut
							element.style.fontWeight = ""; // Poids par défaut
						}
					}
				});
			})
			.catch(error => {
				console.error('Erreur lors de la récupération du panier:', error);
			});
	}

	// Fonction pour mettre à jour toutes les barres de progression
	function updateProgressBar(percentage) {
		const progressBarInners = document.querySelectorAll(".progress-bar-inner");
		progressBarInners.forEach(function (element) {
			element.style.width = percentage + "%";
		});
	}

	// Écouter les changements d'option
	if (homeDeliveryRadio) {
		homeDeliveryRadio.addEventListener("change", function () {
			if (this.checked) {
				updateDeliveryOption("home");
			}
		});
	}

	if (storePickupRadio) {
		storePickupRadio.addEventListener("change", function () {
			if (this.checked) {
				updateDeliveryOption("relay");
			}
		});
	}

	// S'assurer que tous les radio buttons sont focusables
	function ensureRadioButtonsFocusable() {
		const radioButtons = document.querySelectorAll('#custom-delivery-methods input[type="radio"]');
		radioButtons.forEach(radio => {
			radio.setAttribute('tabindex', '0');
		});
	}

	// Appeler la fonction au chargement
	ensureRadioButtonsFocusable();

	// Réappliquer après chaque changement d'état
	const observer = new MutationObserver(function(mutations) {
		mutations.forEach(function(mutation) {
			if (mutation.type === 'attributes' && mutation.attributeName === 'checked') {
				ensureRadioButtonsFocusable();
			}
		});
	});

	// Observer les changements sur les radio buttons
	const radioButtons = document.querySelectorAll('#custom-delivery-methods input[type="radio"]');
	radioButtons.forEach(radio => {
		observer.observe(radio, { attributes: true, attributeFilter: ['checked'] });
	});

	// Initialiser avec l'option par défaut
	const activeOption = document.querySelector('input[name="delivery"]:checked');
	//console.log("Active delivery option found:", activeOption ? activeOption.id : "none");

	if (activeOption) {
		if (activeOption.id === "homeDeliveryRadio") {
			//console.log("Initializing with home delivery");
			updateDeliveryOption("home");
		} else if (activeOption.id === "storePickupRadio") {
			//console.log("Initializing with relay delivery");
			updateDeliveryOption("relay");
		}
	} else {
		// Si aucune option n'est sélectionnée, vérifier la disponibilité du point relais
		if (document.getElementById("storePickupRadio")) {
			//console.log("No option checked, defaulting to relay delivery");
			updateDeliveryOption("relay");
		} else {
			//console.log("No option checked, defaulting to home delivery");
			updateDeliveryOption("home");
		}
	}

	// Mettre à jour les prix de livraison au chargement initial
	setTimeout(() => {
		const currentOption = document.querySelector('input[name="delivery"]:checked');
		if (currentOption) {
			const selectedOption = currentOption.id === "homeDeliveryRadio" ? "home" : "relay";
			// Récupérer le total du panier
			let cartTotal = 0;
			const cartTotalElement = document.querySelector('[data-cart-total-price], .mm-cart-container-total');
			if (cartTotalElement) {
				const totalText = cartTotalElement.textContent || cartTotalElement.innerText || '';
				const totalMatch = totalText.match(/[\d\s,]+[,.]?\d*/);
				if (totalMatch) {
					let cleanAmount = totalMatch[0].replace(/[\s]/g, '').replace(',', '.');
					cartTotal = Math.round(parseFloat(cleanAmount) * 100);
				}
			}

			// Récupérer les seuils
			const dataElement = document.querySelector("[data-delivery-text-home]");
			if (dataElement) {
				const homeThreshold = parseInt(dataElement.dataset.thresholdHome) || 7900;
				const relayThreshold = parseInt(dataElement.dataset.thresholdRelay) || 4900;
				const currentThreshold = selectedOption === "home" ? homeThreshold : relayThreshold;

				updateDeliveryPrices(selectedOption, cartTotal, currentThreshold);
			}
		}
	}, 500);

	// Forcer la mise à jour initiale de la progress bar
	setTimeout(function () {
		const currentOption = document.querySelector('input[name="delivery"]:checked');
		console.log("Final initialization - selected option:", currentOption ? currentOption.id : "none");

		if (currentOption && currentOption.id === "homeDeliveryRadio") {
			// console.log("Final init: Setting to home delivery");
			updateDeliveryOption("home");
			// Afficher les détails de la livraison à domicile
			$("#custom-delivery-methods").find(".deliveryDetails").hide();
			$("#homeDeliveryRadio").closest("li").find(".deliveryDetails").show();
		} else if (currentOption && currentOption.id === "storePickupRadio") {
			// console.log("Final init: Setting to relay delivery");
			updateDeliveryOption("relay");
			// Afficher les détails du point relais
			$("#custom-delivery-methods").find(".deliveryDetails").hide();
			$("#storePickupRadio").closest("li").find(".deliveryDetails").show();
		} else {
			// Si aucune option n'est sélectionnée, vérifier la disponibilité du point relais
			if (document.getElementById("storePickupRadio")) {
				// console.log("Final init: Defaulting to relay delivery");
				updateDeliveryOption("relay");
				// Afficher les détails du point relais
				$("#custom-delivery-methods").find(".deliveryDetails").hide();
				$("#storePickupRadio").closest("li").find(".deliveryDetails").show();
			} else {
				// console.log("Final init: Defaulting to home delivery");
				updateDeliveryOption("home");
				// Afficher les détails de la livraison à domicile
				$("#custom-delivery-methods").find(".deliveryDetails").hide();
				$("#homeDeliveryRadio").closest("li").find(".deliveryDetails").show();
			}
		}
	}, 100);
}

// Exposer la fonction globalement pour la réutiliser
window.initializeDeliveryProgressBar = initializeDeliveryProgressBar;

// Exposer les fonctions du panier globalement pour l'accessibilité
window.mmIncreaseProductQuantity = mmIncreaseProductQuantity;
window.mmDecreaseProductQuantity = mmDecreaseProductQuantity;
window.mmDestroyProductFromCart = mmDestroyProductFromCart;

// Exposer les fonctions de debug pour la sélection de livraison
window.saveDeliverySelection = saveDeliverySelection;
window.restoreDeliverySelection = restoreDeliverySelection;
window.debugDeliverySelection = function() {
	console.log('=== DEBUG SÉLECTION LIVRAISON ===');
	console.log('Sélection sauvegardée:', sessionStorage.getItem('mm_delivery_selection'));
	const selected = document.querySelector('input[name="delivery"]:checked');
	console.log('Sélection actuelle:', selected ? selected.id : 'aucune');
	console.log('Éléments disponibles:', document.querySelectorAll('input[name="delivery"]').length);
	console.log('================================');
};

// Exposer la fonction de debug pour les prix de livraison
window.debugDeliveryPrices = function() {
	console.log('=== DEBUG PRIX LIVRAISON ===');
	const homePriceElements = document.querySelectorAll('#homeDeliveryRadio + div .cart__checkout-subtotal-label');
	const relayPriceElements = document.querySelectorAll('#storePickupRadio + div .cart__checkout-subtotal-label');

	console.log('Éléments prix domicile trouvés:', homePriceElements.length);
	homePriceElements.forEach((el, i) => {
		console.log(`  Domicile ${i+1}:`, el.textContent, 'Prix original:', el.dataset.originalPrice);
	});

	console.log('Éléments prix relais trouvés:', relayPriceElements.length);
	relayPriceElements.forEach((el, i) => {
		console.log(`  Relais ${i+1}:`, el.textContent, 'Prix original:', el.dataset.originalPrice);
	});

	// Récupérer le total du panier
	let cartTotal = 0;
	const cartTotalElement = document.querySelector('[data-cart-total-price], .mm-cart-container-total');
	if (cartTotalElement) {
		const totalText = cartTotalElement.textContent || cartTotalElement.innerText || '';
		const totalMatch = totalText.match(/[\d\s,]+[,.]?\d*/);
		if (totalMatch) {
			let cleanAmount = totalMatch[0].replace(/[\s]/g, '').replace(',', '.');
			cartTotal = Math.round(parseFloat(cleanAmount) * 100);
		}
	}
	console.log('Total panier (centimes):', cartTotal);

	const dataElement = document.querySelector("[data-delivery-text-home]");
	if (dataElement) {
		const homeThreshold = parseInt(dataElement.dataset.thresholdHome) || 7900;
		const relayThreshold = parseInt(dataElement.dataset.thresholdRelay) || 4900;
		console.log('Seuil domicile:', homeThreshold, 'Seuil relais:', relayThreshold);
		console.log('Domicile gratuit:', cartTotal >= homeThreshold);
		console.log('Relais gratuit:', cartTotal >= relayThreshold);
	}

	// Debug de la langue
	console.log('Langue détectée:', getFreeText());
	console.log('HTML lang:', document.documentElement.lang);
	console.log('Body classes:', document.body.className);
	console.log('============================');
};

// Exposer la fonction de test de langue
window.testLanguageDetection = function() {
	console.log('=== TEST DÉTECTION LANGUE ===');
	console.log('HTML lang attribute:', document.documentElement.lang);
	console.log('Body classes:', document.body.className);
	console.log('Texte gratuit détecté:', getFreeText());
	console.log('=============================');
};

// Exposer la fonction de debug pour les compteurs de panier
window.debugCartCounters = function() {
	console.log('=== DEBUG COMPTEURS PANIER ===');

	// Récupérer le panier actuel
	fetch('/cart.js')
		.then(response => response.json())
		.then(cart => {
			console.log('Panier actuel (API):', cart.item_count, 'articles');

			// Vérifier les éléments DOM
			const headerCount = document.querySelector("#js-header-cart-count");
			const drawerCount = document.querySelector(".mm-cart-count-bubble");

			console.log('Header counter (#js-header-cart-count):', headerCount ? headerCount.innerText : 'NON TROUVÉ');
			console.log('Drawer counter (.mm-cart-count-bubble):', drawerCount ? drawerCount.innerText : 'NON TROUVÉ');

			// Vérifier la cohérence
			const headerValue = headerCount ? parseInt(headerCount.innerText) : 0;
			const drawerValue = drawerCount ? parseInt(drawerCount.innerText) : 0;

			console.log('Cohérence:');
			console.log('  API vs Header:', cart.item_count === headerValue ? 'OK' : 'ERREUR');
			console.log('  API vs Drawer:', cart.item_count === drawerValue ? 'OK' : 'ERREUR');
			console.log('  Header vs Drawer:', headerValue === drawerValue ? 'OK' : 'ERREUR');

			if (cart.item_count !== headerValue || cart.item_count !== drawerValue) {
				console.log('🔧 Correction automatique en cours...');
				updateCartCount(cart.item_count);
			}
		})
		.catch(error => {
			console.error('Erreur lors de la récupération du panier:', error);
		});

	console.log('==============================');
};

// Gestion du container CTA sticky mobile
function initStickyMobileCart() {
	const stickyContainer = document.querySelector('.mm-cart-sticky-mobile');
	const checkoutButtonContainer = document.querySelector('.cart__checkout-button-container');

	if (!stickyContainer || !checkoutButtonContainer) {
		return;
	}

	function checkVisibility() {
		if (window.innerWidth >= 768) {
			stickyContainer.classList.remove('show');
			return;
		}

		// Vérifier si le cart__checkout-button-container est visible
		const rect = checkoutButtonContainer.getBoundingClientRect();
		const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

		if (!isVisible) {
			stickyContainer.classList.add('show');
		} else {
			stickyContainer.classList.remove('show');
		}
	}

	// Vérifier au scroll et au resize
	window.addEventListener('scroll', debounce(checkVisibility, 100));
	window.addEventListener('resize', debounce(checkVisibility, 100));

	checkVisibility();
}

document.addEventListener('DOMContentLoaded', function() {
	initStickyMobileCart();
});

// Réinitialiser après les mises à jour du panier
function refreshStickyMobileCart() {
	const cartTotalElement = document.querySelector('.mm-cart-sticky-total-price[data-cart-total-price]');
	const originalTotalElement = document.querySelector('[data-cart-total-price]');

	if (cartTotalElement && originalTotalElement) {
		cartTotalElement.textContent = originalTotalElement.textContent;
	}

	setTimeout(initStickyMobileCart, 100);
}